import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {ApplicationService} from '../../services/application.service';
import {environment} from '../../../environments/environment';
import {EnumerationService} from '../../services/enumeration.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ExcRestService} from 'exc-rest-v2';

@Component({
  selector: 'app-receipt-file-upload',
  templateUrl: './receipt-file-upload.component.html',
})
export class ReceiptFileUploadComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  SummaryAttachmentTable: any;
  ConfigAttachmentTable: any;

  selectedFiles: ExcFileItem[] = [];
  acceptedFileTypes = ['PDF', 'DOCX', 'XLSX', 'JPEG', 'PNG'];

  files = {
    selection: [],
  };

  private _MAXFILESIZE = environment.rest.MAXFILESIZE;
  get MAXFILESIZE(): number {
    return this._MAXFILESIZE;
  }

  skipFileUpload = false;
  mergeFileUpload = false;

  showUpload = true;
  showDocuments = false;

  receipt = {
    rcpt_vorgID: undefined,
    rcptStatement: false,
    rcptStatementReason: '',
  };
  localConfig = {
    openAttachmentInBrowser: (doc: any): void => {
      if (doc.dokMIME.includes('/pdf') || doc.dokMIME.includes('image/')) {
        this.appSvc.file.dokument.openInBrowser(doc.dokID);
      }
      else {
        this.modalService.showToast(this.getRessource('OpenInBrowser.NotOpenInBrowser'), 'md-toast', 'fas fa-exclamation');
      }
    },
    addAttachmentToUpload: (doc: any): void => {
      if (this.isValidPDFExtension(doc.dokExtension)) {
        this.excRest.get(
            this.excRest.computeUrl('DocumentR', {dokID: doc.dokID}), {})
          .subscribe((rtVal: any) => {
            const docFile = this.base64ToFile(
              rtVal.data.IMG,
              doc.dokName,
              doc.dokMIME
            );

            this.selectedFiles.push(
              ExcFileItem.fromFile(docFile)
            );
          });
      }
    }
  };

  constructor(public modalService: ExgModalService,
              public appSvc: ApplicationService,
              public enumSvc: EnumerationService,
              public excRest: ExcRestService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data) {
      this.receipt = JSON.parse(JSON.stringify(this.data.Data));
      this.SummaryAttachmentTable = this.data.SummaryAttachmentTable;
      this.ConfigAttachmentTable = this.data.ConfigAttachmentTable;

      for (const folder of this.SummaryAttachmentTable?.jagdata) {
        for (const doc of folder.documents) {
            doc.dokExtension = doc.dokName.slice(doc.dokName.lastIndexOf('.') + 1);
        }
      }
    }
  }

  onFilesSelect(files: ExcFileItem): void {
    this.selectedFiles = this.selectedFiles.concat(files);
  }

  delete(index: any): void {
    this.selectedFiles = this.selectedFiles.filter(file => file !== index);
  }

  isValidPDF(fileSize: number, fileExtension: string): boolean {
    return this.proofFileSize(fileSize) && this.isValidPDFExtension(fileExtension);
  }

  isValidPDFExtension(fileExtension: string): boolean {
    if (fileExtension) {
      return this.acceptedFileTypes.includes(fileExtension.toUpperCase());
    }
    return false;
  }

  proofFileSize(size: number): boolean {
    return size < this.MAXFILESIZE;
  }

  getFiles(): any[] {
    const files = this.selectedFiles.filter((file: any) => this.isValidPDF(file.size, file.extension));
    if (!files || this.skipFileUpload) {
      return [];
    }
    return files;
  }

  upload(): void {
    if (
      (this.getFiles().length > 0 && !this.skipFileUpload)
      || this.skipFileUpload
    ) {
      this.modalService.action({
        formData: ExcFileItem.getFormData(this.getFiles(), this.receipt)
        , mergeFileUpload: this.mergeFileUpload
        , skipFileUpload: this.skipFileUpload
      });
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalService.close();
  }

  move(index: number, dir: -1 | 1): void {
    const target = index + dir;
    if (target < 0 || target >= this.selectedFiles.length) {
      return;
    }
    const copy = [...this.selectedFiles];
    [copy[index], copy[target]] = [copy[target], copy[index]];
    this.selectedFiles = copy;
  }

  onFileDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.selectedFiles, event.previousIndex, event.currentIndex);
      this.selectedFiles = [...this.selectedFiles];
    }
  }

  base64ToFile(
    base64: string,
    fileName: string,
    mimeType: string
  ): File {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new File(
      [bytes],
      fileName,
      { type: mimeType }
    );
  }
}
